(function() {
    'use strict';

    // ===== 1. Hide upgrade pack from storefront listings =====
    function hideUpgradePack() {
        var upgradeLinks = document.querySelectorAll('a[href*="diy-crystal-bracelet-1"]');
        upgradeLinks.forEach(function(el) {
            var card = el.closest('.product-card, .card, .grid__item, .collection-item, [data-product-card], .product-item, .card--product');
            if (card) {
                card.style.display = 'none';
            }
        });
        
        if (window.location.pathname.includes('/collections/') || window.location.pathname.includes('/search')) {
            var productCards = document.querySelectorAll('.product-card, .card--product, .grid__item');
            productCards.forEach(function(card) {
                var link = card.querySelector('a[href*="diy-crystal-bracelet-1"]');
                if (link) {
                    card.style.display = 'none';
                }
            });
        }
    }

    // ===== 2. Fix Chinese text remnants =====
    function fixChineseText() {
        var replacements = {
            '\u624b\u9556\u8bbe\u8ba1': 'Style',
            '\u65b0\u95fb': 'Blog',
            '\u624b\u94fe': 'Bracelet',
            '\u6c34\u6676': 'Crystal',
            '\u4ea7\u54c1': 'Products',
            '\u5173\u4e8e': 'About',
            '\u8054\u7cfb': 'Contact'
        };
        var allElements = document.querySelectorAll('span, div, a, p, li, td, th, label, legend, h1, h2, h3, h4, h5, h6');
        allElements.forEach(function(el) {
            if (el.children.length === 0) {
                var text = el.textContent.trim();
                Object.keys(replacements).forEach(function(cn) {
                    if (text === cn || text.includes(cn)) {
                        el.textContent = text.replace(cn, replacements[cn]);
                    }
                });
            }
        });
    }

    // ===== 3. Fix price display on DIY product page =====
    function fixDIYPriceDisplay() {
        if (!window.location.pathname.includes('/products/diy-crystal-bracelet')) return;
        var priceElements = document.querySelectorAll('.price-item, .product__price, [data-product-price]');
        priceElements.forEach(function(el) {
            var text = el.textContent.trim();
            var pricePattern = /\$0\.00/;
            if (pricePattern.test(text)) {
                el.innerHTML = 'Starting from <span style="font-weight:600;color:#c9a96e">$15</span>';
            }
        });
    }

    // ===== 4. Fix duplicate H1 on homepage =====
    function fixDuplicateH1() {
        var h1s = document.querySelectorAll('h1');
        if (h1s.length > 1) {
            for (var i = 1; i < h1s.length; i++) {
                var h1 = h1s[i];
                var h2 = document.createElement('h2');
                h2.innerHTML = h1.innerHTML;
                h2.className = h1.className;
                h2.id = h1.id;
                h2.style.cssText = h1.style.cssText;
                for (var j = 0; j < h1.attributes.length; j++) {
                    var attr = h1.attributes[j];
                    if (attr.name !== 'class' && attr.name !== 'id' && attr.name !== 'style') {
                        h2.setAttribute(attr.name, attr.value);
                    }
                }
                h1.parentNode.replaceChild(h2, h1);
            }
            console.log('[XIDU] Fixed duplicate H1: converted extra H1 tags to H2');
        }
    }

    // ===== 5. Add OG Image fallback via JS =====
    function addOGImage() {
        if (document.querySelector('meta[property="og:image"]')) return;
        var ogImage = 'https://cdn.shopify.com/s/files/1/0741/2278/8942/files/1_1_90e7d365-1311-4634-bb1d-fbf7f7418be5.png?v=1781080063';
        var meta = document.createElement('meta');
        meta.setAttribute('property', 'og:image');
        meta.setAttribute('content', ogImage);
        document.head.appendChild(meta);
        
        var metaSecure = document.createElement('meta');
        metaSecure.setAttribute('property', 'og:image:secure_url');
        metaSecure.setAttribute('content', ogImage);
        document.head.appendChild(metaSecure);
    }

    // ===== 6. Add FAQ Schema =====
    function addFAQSchema() {
        if (window.location.pathname !== '/') return;
        if (document.querySelector('script[type="application/ld+json"][data-faq]')) return;
        
        var faqData = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "Are your crystal bracelets handmade?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Yes, every bracelet is handmade with natural crystals and gemstones."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Do you offer free shipping?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Yes, we offer free shipping on orders over $30."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Can I customize my own bracelet?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Yes, use our DIY Crystal Bracelet customizer to design your own unique piece."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What is your return policy?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "We accept returns within 30 days of delivery for unused items in original condition."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How long does shipping take?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Standard shipping takes 7-14 business days. Express options available at checkout."
                    }
                }
            ]
        };
        
        var script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-faq', 'true');
        script.textContent = JSON.stringify(faqData);
        document.head.appendChild(script);
    }

    // ===== 7. Add Mobile Meta Tags =====
    function addMobileMeta() {
        if (!document.querySelector('meta[name="apple-mobile-web-app-capable"]')) {
            var meta = document.createElement('meta');
            meta.name = 'apple-mobile-web-app-capable';
            meta.content = 'yes';
            document.head.appendChild(meta);
        }
        if (!document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]')) {
            var meta2 = document.createElement('meta');
            meta2.name = 'apple-mobile-web-app-status-bar-style';
            meta2.content = 'black-translucent';
            document.head.appendChild(meta2);
        }
    }

    // ===== 8. Add Trust Badges =====
    function addTrustBadges() {
        if (document.querySelector('.xidu-trust-badges')) return;
        var footer = document.querySelector('footer, .footer, .site-footer');
        if (!footer) return;
        
        var container = document.createElement('div');
        container.className = 'xidu-trust-badges';
        container.style.cssText = 'display:flex;flex-wrap:wrap;justify-content:center;gap:20px;padding:20px 0;max-width:1200px;margin:0 auto;';
        
        var badges = [
            {icon: '\u2705', text: '100% Natural Crystals'},
            {icon: '\u2709\ufe0f', text: 'Free Shipping Over $50'},
            {icon: '\u21a9\ufe0f', text: '30-Day Returns'},
            {icon: '\ud83d\udd12', text: 'Secure Checkout'}
        ];
        
        badges.forEach(function(b) {
            var div = document.createElement('div');
            div.style.cssText = 'display:flex;align-items:center;gap:8px;font-size:13px;color:#555;';
            div.innerHTML = '<span style="font-size:18px">' + b.icon + '</span><span>' + b.text + '</span>';
            container.appendChild(div);
        });
        
        footer.insertBefore(container, footer.firstChild);
    }

    // ===== 9. Add Social Links =====
    function addSocialLinks() {
        if (document.querySelector('.xidu-social-links')) return;
        var footer = document.querySelector('footer, .footer, .site-footer');
        if (!footer) return;
        
        var container = document.createElement('div');
        container.className = 'xidu-social-links';
        container.style.cssText = 'display:flex;justify-content:center;gap:15px;padding:15px 0;';
        
        var links = [
            {url: 'https://www.tiktok.com/@xidu_diy', icon: 'TikTok'},
            {url: 'https://www.instagram.com/xidu_diy', icon: 'Instagram'},
            {url: 'https://www.facebook.com/xidu_diy', icon: 'Facebook'},
            {url: 'https://www.pinterest.com/xidu_diy', icon: 'Pinterest'}
        ];
        
        links.forEach(function(l) {
            var a = document.createElement('a');
            a.href = l.url;
            a.target = '_blank';
            a.rel = 'noopener';
            a.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;border-radius:50%;background:#1a1a2e;color:#fff;font-size:11px;text-decoration:none;font-weight:600;';
            a.textContent = l.icon.substring(0, 2);
            a.title = l.icon;
            container.appendChild(a);
        });
        
        footer.insertBefore(container, footer.firstChild);
    }

    // ===== 10. Add Social Share Buttons =====
    function addSocialShare() {
        if (window.location.pathname.indexOf('/products/') === -1) return;
        if (document.querySelector('.xidu-share-buttons')) return;
        
        var productForm = document.querySelector('.product-form, .product__info, .product__main');
        if (!productForm) return;
        
        var container = document.createElement('div');
        container.className = 'xidu-share-buttons';
        container.style.cssText = 'display:flex;align-items:center;gap:10px;margin:15px 0;padding:10px 0;';
        
        var label = document.createElement('span');
        label.textContent = 'Share:';
        label.style.cssText = 'font-size:14px;font-weight:600;color:#555;';
        container.appendChild(label);
        
        var pageUrl = encodeURIComponent(window.location.href);
        var pageTitle = encodeURIComponent(document.title);
        
        var shares = [
            {url: 'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl, icon: 'F', color: '#1877f2'},
            {url: 'https://twitter.com/intent/tweet?url=' + pageUrl + '&text=' + pageTitle, icon: 'T', color: '#1da1f2'},
            {url: 'https://pinterest.com/pin/create/button/?url=' + pageUrl, icon: 'P', color: '#e60023'}
        ];
        
        shares.forEach(function(s) {
            var a = document.createElement('a');
            a.href = s.url;
            a.target = '_blank';
            a.rel = 'noopener';
            a.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:50%;background:' + s.color + ';color:#fff;font-size:14px;text-decoration:none;font-weight:700;';
            a.textContent = s.icon;
            container.appendChild(a);
        });
        
        productForm.appendChild(container);
    }

    // ===== 11. Add Urgency Badge =====
    function addUrgencyBadge() {
        if (window.location.pathname.indexOf('/products/') === -1) return;
        if (document.querySelector('.xidu-urgency')) return;
        
        var productForm = document.querySelector('.product-form, .product__info, .product__main');
        if (!productForm) return;
        
        var div = document.createElement('div');
        div.className = 'xidu-urgency';
        div.style.cssText = 'display:flex;align-items:center;gap:8px;padding:8px 12px;background:#fff3cd;border:1px solid #ffeaa7;border-radius:6px;margin:10px 0;font-size:13px;color:#856404;';
        
        var viewers = Math.floor(Math.random() * 30) + 15;
        div.innerHTML = '<span style="font-size:16px">\ud83d\udc41</span><span>' + viewers + ' people are viewing this product</span>';
        
        productForm.insertBefore(div, productForm.firstChild);
    }

    // ===== 12. Enhance Organization Schema =====
    function enhanceOrganizationSchema() {
        if (document.querySelector('[data-xidu-org-schema]')) return;
        
        var orgData = {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "XIDU DIY Shop",
            "url": "https://xidudiy.com",
            "logo": "https://cdn.shopify.com/s/files/1/0741/2278/8942/files/1_1_90e7d365-1311-4634-bb1d-fbf7f7418be5.png?v=1781080063",
            "description": "Custom crystal bracelets, music-inspired jewelry, and handmade accessories.",
            "sameAs": [
                "https://www.tiktok.com/@xidu_diy",
                "https://www.instagram.com/xidu_diy",
                "https://www.facebook.com/xidu_diy",
                "https://www.pinterest.com/xidu_diy"
            ]
        };
        
        var script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-xidu-org-schema', 'true');
        script.textContent = JSON.stringify(orgData);
        document.head.appendChild(script);
    }

    // ===== 13. Add WebSite Schema with SearchAction =====
    function addWebSiteSchema() {
        if (document.querySelector('[data-xidu-website-schema]')) return;
        
        var siteData = {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "url": "https://xidudiy.com",
            "name": "XIDU DIY Shop",
            "potentialAction": {
                "@type": "SearchAction",
                "target": "https://xidudiy.com/search?q={search_term_string}",
                "query-input": "required name=search_term_string"
            }
        };
        
        var script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-xidu-website-schema', 'true');
        script.textContent = JSON.stringify(siteData);
        document.head.appendChild(script);
    }

    // ===== 14. Add Estimated Delivery Date =====
    function addEstimatedDelivery() {
        if (window.location.pathname.indexOf('/products/') === -1) return;
        if (document.querySelector('.xidu-estimated-delivery')) return;
        
        var productForm = document.querySelector('.product-form, .product__info, .product__main');
        if (!productForm) return;
        
        var today = new Date();
        var minDays = 7;
        var maxDays = 14;
        var minDate = new Date(today.getTime() + minDays * 24 * 60 * 60 * 1000);
        var maxDate = new Date(today.getTime() + maxDays * 24 * 60 * 60 * 1000);
        
        var fmt = function(d) {
            var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            return months[d.getMonth()] + ' ' + d.getDate();
        };
        
        var div = document.createElement('div');
        div.className = 'xidu-estimated-delivery';
        div.style.cssText = 'padding:8px 0;font-size:13px;color:#555;';
        div.innerHTML = '<span style="font-size:16px">\ud83d\ude9a</span> Estimated delivery: <strong>' + fmt(minDate) + ' - ' + fmt(maxDate) + '</strong>';
        
        productForm.appendChild(div);
    }

    // ===== 15. Add Free Shipping Progress Bar =====
    function addFreeShippingBar() {
        if (document.querySelector('.xidu-free-shipping-bar')) return;
        
        var bar = document.createElement('div');
        bar.className = 'xidu-free-shipping-bar';
        bar.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#1a1a2e;color:#fff;text-align:center;padding:8px;font-size:13px;z-index:9999;';
        bar.innerHTML = '\ud83d\uded2 Free shipping on orders over <strong>$50</strong>';
        
        document.body.appendChild(bar);
        
        // Hide on checkout pages
        if (window.location.pathname.indexOf('/checkout') !== -1 || window.location.pathname.indexOf('/cart') !== -1) {
            bar.style.display = 'none';
        }
    }

    // ===== INIT =====
    function init() {
        hideUpgradePack();
        fixChineseText();
        fixDIYPriceDisplay();
        fixDuplicateH1();
        addOGImage();
        addFAQSchema();
        addMobileMeta();
        addTrustBadges();
        addSocialLinks();
        addSocialShare();
        addUrgencyBadge();
        enhanceOrganizationSchema();
        addWebSiteSchema();
        addEstimatedDelivery();
        addFreeShippingBar();
  addProductSchema();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
    setTimeout(init, 1500);
    setTimeout(init, 3000);
})();

  // Product Page Schema - adds structured data for product pages
  function addProductSchema() {
    if (window.location.pathname.indexOf('/products/') === -1) return;
    
    // Check if product schema already exists
    var existing = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < existing.length; i++) {
      if (existing[i].textContent.indexOf('"Product"') !== -1) return;
    }
    
    // Get product data from page
    var productJsonEl = document.getElementById('product-json');
    var productData = null;
    
    // Try to get product data from Shopify format
    var productForm = document.querySelector('form[action*="/cart/add"]');
    var productId = '';
    if (productForm) {
      var idInput = productForm.querySelector('input[name="id"]');
      if (idInput) productId = idInput.value;
    }
    
    // Get product title
    var h1 = document.querySelector('h1');
    var productTitle = h1 ? h1.textContent.trim() : document.title;
    
    // Get product description (first paragraph)
    var descEl = document.querySelector('.product-description p, .rte p, [itemprop="description"]');
    var productDesc = descEl ? descEl.textContent.trim().substring(0, 200) : '';
    
    // Get product image
    var imgEl = document.querySelector('.product-image img, [itemprop="image"] img, .product__media img');
    var productImage = imgEl ? imgEl.src : '';
    
    // Get price
    var priceEl = document.querySelector('.price, [itemprop="price"], .product-price');
    var productPrice = '';
    if (priceEl) {
      var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
      productPrice = priceText;
    }
    
    // Get availability
    var availEl = document.querySelector('[itemprop="availability"]');
    var availability = availEl ? 'https://schema.org/InStock' : 'https://schema.org/InStock';
    
    if (!productTitle || !productPrice) return;
    
    var schema = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": productTitle,
      "description": productDesc,
      "image": productImage,
      "offers": {
        "@type": "Offer",
        "price": productPrice,
        "priceCurrency": "USD",
        "availability": availability,
        "url": window.location.href
      },
      "brand": {
        "@type": "Brand",
        "name": "XIDU DIY"
      }
    };
    
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }